import {constractMapUrl, constractMapUrlWithDirections} from "@/libs/helper";

export const NeoLocation: React.FC<any> = ({data, uid}) => {
  //console.log(data, uid);
  const latLngs = data[uid] || [];
  return (
    <>
      <div className="flex gap-1">
        {Array.isArray(latLngs)
          ? latLngs.length > 1
            ? // Multiple points Used Google Maps Directions URL LIKE (https://www.google.com/maps/dir/)
              (() => {
                const directionUrl = constractMapUrlWithDirections(latLngs);
                return (
                  <a
                    href={directionUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-blue-600 underline hover:text-blue-800"
                  >
                    Location
                  </a>
                );
              })()
            : // Single point Google Maps URL LIKE (https://www.google.com/maps/search/?api=1&query=lat,lng)
              // ["latLLng"] If latLngs is an array with a single value, we can still use the same logic
              latLngs.map((latLng: string, index: number) => {
                const [lat, lng] = latLng.split(",");
                const mapUrl = constractMapUrl(lat, lng);
                return (
                  <a
                    key={index}
                    href={mapUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-blue-600 underline hover:text-blue-800"
                  >
                    Location
                  </a>
                );
              })
          : // latLngs is a single value (string)
            (() => {
              const [lat, lng] = latLngs.split(",");
              const mapUrl = constractMapUrl(lat, lng);
              return (
                <a
                  href={mapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-blue-600 underline hover:text-blue-800"
                >
                  Location
                </a>
              );
            })()}
      </div>
    </>
  );
};
